// extracted by mini-css-extract-plugin
export default {"container":"bG_g","arrowLeft":"bG_hB","arrowRight":"bG_hC","dots":"bG_hD"};